import React, {Component} from 'react';
import { Link } from 'react-router-dom'; 
import { base_url} from '../common/Constants'; 
import { SharedContext } from '../pages/createContext';
import withRouter from '../components/withRouter';

class Header extends Component {
    static contextType = SharedContext;
    
    constructor(props){
        super(props);
        
        this.state = {
            scrolled: false,
            slug : "",
            mobile:0,
            mobileAbout:'closed',
            mobileDivision:'closed',
            mobileProjects:'closed'
          };
        }
      
        componentDidMount() {
          window.addEventListener('scroll', this.handleScroll);

          const slug = ((this.props.slug || '').split('/').filter(Boolean)[0]) ?? this.props.slug;

          this.setState({ slug: slug}); 
          
        }
      
        componentWillUnmount() {
          window.removeEventListener('scroll', this.handleScroll);
        }
      
        handleScroll = () => {
          const isScrolled = window.scrollY > 50;
          if (isScrolled !== this.state.scrolled) {
            this.setState({ scrolled: isScrolled });
          }
        }; 

      handleMobileMenu = (event) => { this.setState({mobile:this.state.mobile === 0 ? 1 : 0}); }
      handleAbout = (event) => { this.setState({mobileAbout:this.state.mobileAbout === 'closed' ? 'open' : 'closed'});}
      handleDivision = (event) => { this.setState({mobileDivision:this.state.mobileDivision === 'closed' ? 'open' : 'closed'});}
      handleProjects = (event) => { this.setState({mobileProjects:this.state.mobileProjects === 'closed' ? 'open' : 'closed'});}
      
    render()
    {
        
     
  return (
    <div>

 <header class= { this.state.mobile === 0 ? "site-header header-style-1 mobile-sider-drawer-menu"  : "site-header header-style-1 mobile-sider-drawer-menu active" }>
        
            <div class="top-bar bg-secondry">
                <div class="container">
                    <div class="wt-topbar-right">
                        <ul class="list-unstyled e-p-bx">
                            <li><i class="fa fa-envelope"></i>{JSON.parse(localStorage.getItem("settings")).site_email_address}</li>
                            <li><i class="fa fa-phone"></i>{JSON.parse(localStorage.getItem("settings")).site_factory_number}</li>
                        </ul>
                     
                    </div>
                </div>
            </div>
            
            <div class="sticky-header main-bar-wraper">
                <div class="main-bar bg-white">
                    <div class="container">
                        <div class="logo-header">
                            <Link to="/">
                                <img src={JSON.parse(localStorage.getItem("settings")).site_logo}  width="171" height="80" alt=""  />
                            </Link>
                        </div>
                        
                       
                        <div class="header-nav navbar-collapse collapse ">
                            <ul class=" nav navbar-nav">
                                <li  class={this.state.slug === "" ? "active" : ""}>
                                    <Link to="/">Home</Link>
                                </li>
                                
                                
                                <li class={this.state.mobileAbout === "open"|| this.state.slug === "about-us"  || this.state.slug ===  "vision-mission" || this.state.slug ===  "quality-policy"  || this.state.slug ===  "hse-policy"  
                                    || this.state.slug ===  "environmental-policy"  || this.state.slug ===  "certificates"  || this.state.slug ===  "director-message" ? "active" : ""}>
                                    <Link onClick={this.handleAbout}>About us<i class="fa fa-chevron-down"></i></Link>
                                    <ul  class={this.state.mobileAbout === "open"? "sub-menu dblock" : "sub-menu dnone" }>
                                        
                                        <li><Link to={base_url+`about-us`}>About Us</Link></li>
                                        <li><Link to={base_url+`vision-mission`}>Vision and Mission</Link></li>
                                        <li><Link to={base_url+`quality-policy`}>Quality Policy</Link></li>
                                        <li><Link to={base_url+`hse-policy`}>HSE Policy</Link></li>
                                        <li><Link to={base_url+`environmental-policy`}>Environmental Policy</Link></li> 
                                        <li><Link to={base_url+`certificates`}>Certificates</Link></li>
                                        <li><Link to={base_url+`director-message`}>Executive Director’s Message</Link></li> 
                                    </ul>
                                </li>
                            
                                <li class={this.state.mobileDivision === "open"|| this.state.slug  === "divisions" ? "active" : ""}>
                                    <Link  onClick={this.handleDivision}>Division<i class="fa fa-chevron-down"></i></Link>
                                    <ul  class={this.state.mobileDivision === "open"? "sub-menu dblock" : "sub-menu dnone" }>
                                         {JSON.parse(localStorage.getItem("divisions")).map((item, index) => (
                                <li><Link to={base_url+`divisions/${item.slug}`}>{item.title}</Link></li>
                            ))} 
                                    </ul>
                                </li>
                                
                                <li  class={this.state.slug === "services" ? "active submenu-direction" : "submenu-direction"} > <Link to={base_url+`services`}>Services</Link> </li>
								{/* <li  class={this.state.mobileProjects === "open"|| this.state.slug === "projects" || this.state.slug === "ongoing-projects" ? "active" : ""}>
                                    <Link  onClick={this.handleProjects}>Projects<i class="fa fa-chevron-down"></i></Link>
                                    <ul class={this.state.mobileProjects === "open"? "sub-menu dblock" : "sub-menu dnone" } >
                                        <li><Link to={base_url+`projects`}>Projects</Link></li>
                                      <li><Link to={base_url+`ongoing-projects`}>Ongoing projects</Link></li>
                                        
                                    </ul>
                                </li>*/}
								<li  class={this.state.slug === "projects" ? "active submenu-direction" : "submenu-direction"} > <Link to={base_url+`projects`}>Projects</Link> </li>
								<li  class={this.state.slug === "maintenance-services " ? "active submenu-direction" : "submenu-direction"} > <Link to={base_url+`maintenance-services`}>Maintenance Services</Link> </li>
								<li  class={this.state.slug === "careers" ? "active submenu-direction" : "submenu-direction"} > <Link to={base_url+`careers`}>Careers</Link> </li>
								
								<li  class={this.state.slug === "contact-us" ? "active submenu-direction" : "submenu-direction"} > <Link to={base_url+`contact-us`}>contact us</Link> </li>
                                
                                
</ul>
                        
                    
                         </div>
                          
                        <button id="mobile-side-drawer" data-target=".header-nav" onClick={this.handleMobileMenu} data-toggle="collapse" type="button" class="navbar-toggler collapsed">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar icon-bar-first"></span>
                            <span class="icon-bar icon-bar-two"></span>
                            <span class="icon-bar icon-bar-three"></span>
                        </button>
                        
                    </div>
                </div>
            </div>
            
        </header>
           
    </div>
    
     
    
  );
}
};
 
export default withRouter(Header);;